import { Dispatch, SetStateAction } from 'react';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { UserEndpointQueryKeys } from '../../../../Shared/constants/user/endpoints';
import { ApiError } from '../../../../Shared/interfaces/ApiError';
import { ApiResponseKeys } from '../../../../Shared/interfaces/ApiResponse';
import useApiClient from '../../../../Shared/services/api';
import { deleteUser } from '../../../../Shared/services/user/userService';

export const useDeleteUserMutation = (
  setDeleteModal: Dispatch<SetStateAction<boolean>>,
  setCurrentPage: Dispatch<SetStateAction<number>>,
  setCustomSnackbarMessage: (message: string) => void
) => {
  const queryClient = useQueryClient();
  const api = useApiClient();
  return useMutation<
    ApiResponseKeys,
    ApiError,
    { userId: string; successMessage: string }
  >({
    mutationFn: ({ userId }: { userId: string }) => deleteUser(api, userId),
    onSuccess: (_, { successMessage }) => {
      queryClient.invalidateQueries({
        queryKey: [UserEndpointQueryKeys.GET_USERS],
      });
      setCurrentPage(0);
      setDeleteModal(false);

      setCustomSnackbarMessage(successMessage);
    },
  });
};
